import React, { RefObject, useRef } from "react";
import Left from "./Components/Left";
import Preview from "./Components/Preview";
import Right from "./Components/Right";
import { HashRouter as Router, Route } from "react-router-dom";
import { ApolloError, gql, useQuery } from "@apollo/client";
import { LoadUser } from "./__generated__/LoadUser";

import { ChakraProvider, HStack } from "@chakra-ui/react";
import theme from "./Theme";
import Loader from "./Components/Helpers/Loader";
import { setLoading, setProjectId, setUser } from "./Store/GlobalReducer";
import { useAppDispatch, useAppSelector } from "./Store/hooks";

const USER_QUERY = gql`
  query LoadUser {
    user {
      id
      login
      accessLevel
    }
  }
`;

const LOAD_SETTINGS = gql`
  query LoadSettings {
    settings {
      defaultProject {
        id
      }
    }
  }
`;

const App = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.global.loading);
  const canvas: RefObject<HTMLCanvasElement> = useRef<HTMLCanvasElement>(null);
  const compassRef = useRef<HTMLDivElement>(null);
  const { data } = useQuery<LoadUser>(USER_QUERY, {
    onError: (err: ApolloError) => {
      console.error(`Ошибка`, err.message);
      alert(`Ошибка: ${err.message}`);
    },
    onCompleted: () => {
      if (data && data.user !== null) dispatch(setUser(data.user));
      dispatch(setLoading(false));
    },
  });
  const settingsQuery = useQuery(LOAD_SETTINGS, {
    onCompleted: () => {
      if (
        settingsQuery &&
        settingsQuery.data &&
        settingsQuery.data.settings &&
        settingsQuery.data.settings.defaultProject
      )
        dispatch(setProjectId(settingsQuery.data.settings.defaultProject.id));
    },
  });
  return (
    <Router hashType="noslash">
      <ChakraProvider theme={theme}>
        <Route exact path="/">
          <HStack align="stretch" bg="#cec9bd">
            <Left />
            <Preview canvasRef={canvas} compassRef={compassRef} />
            <Right canvasRef={canvas} compassRef={compassRef} />
          </HStack>
          {loading && <Loader />}
        </Route>
      </ChakraProvider>
    </Router>
  );
};

export default App;
